import React, { useLayoutEffect, useState, Ref } from 'react';

export const useIsLayoutMounted = () => {
  const [isMounted, setIsMounted] = React.useState(false);
  useLayoutEffect(() => setIsMounted(true), [setIsMounted]);

  return isMounted;
};

export const useGetElementDimensions = (ref: Ref) => {
  const [dimensions, setDimensions] = useState({
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
  });

  useLayoutEffect(() => {
    if (ref?.current) {
      const elementDimensions = ref.current.getBoundingClientRect();
      if (Object.keys(elementDimensions)) {
        setDimensions(elementDimensions);
      }
    }
  }, [ref, setDimensions]);

  return dimensions;
};
